import styled from "styled-components";
import { Link } from "react-router-dom";

import BodyText from "core/BodyText";
import Button from "core/Button";
import searchIcon from "./icon-search.svg";

import { convertPxToRem } from "frontend/components/helpers";
import breakpoints from "core/breakpoints";
import { SHARED_FORM_STYLES } from "core/Form";
import {
    BlueBorderBottomLinkStylesDefault,
    BlueBorderBottomLinkStylesHover
} from "core/Typography";

import SectionContainer from "core/SectionContainer";

export const SubpageContainer = styled(SectionContainer).attrs({
    topSpacing: "2xl",
    bottomSpacing: "none",
    removeLeftRightPadding: true
})`
    section:not(:last-child) {
        margin-bottom: ${convertPxToRem({ px: 48 })};

        @media (max-width: ${breakpoints.beforeTablet.rem}) {
            margin-bottom: ${convertPxToRem({ px: 40 })};
        }

        @media (max-width: ${breakpoints.beforeDesktop.rem}) {
            margin-bottom: ${convertPxToRem({ px: 32 })};
        }
    }
`;

export const StyledTextLink = styled(Link)`
    text-decoration: none;

    ${BodyText} {
        ${BlueBorderBottomLinkStylesDefault}
        &:hover {
            ${BlueBorderBottomLinkStylesHover}
        }
    }
`;

export const SearchAndLinkContainer = styled.div`
    display: flex;
    justify-content: ${({ noSearch }) =>
        noSearch ? "flex-end" : "space-between"};
    align-items: center;
    margin-bottom: ${convertPxToRem({ px: 40 })};

    @media (max-width: ${breakpoints.beforeDesktop.rem}) {
        margin-bottom: ${convertPxToRem({ px: 36 })};
    }

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        margin-bottom: ${convertPxToRem({ px: 32 })};
    }
`;

export const BrowseAllContentCTABase = styled(Button)`
    display: block;
    margin: 0 auto;
    margin-top: ${convertPxToRem({ px: 40 })};

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        margin-top: ${convertPxToRem({ px: 36 })};
    }

    @media (max-width: ${breakpoints.beforeDesktop.rem}) {
        margin-top: ${convertPxToRem({ px: 32 })};
    }
`;

export const SearchInput = styled.input.attrs({
    type: "text",
    "data-testid": "creator-icon-search-input",
    style: {
        backgroundImage: `url(${searchIcon})`
    }
})`
    ${SHARED_FORM_STYLES.BASE}
    padding-left: ${convertPxToRem({ px: 32 })};
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: ${convertPxToRem({ px: 9 })};
    background-size: ${convertPxToRem({ px: 16 })} ${convertPxToRem({
    px: 16
})};
    width: ${convertPxToRem({ px: 250 })};
    margin-bottom: ${convertPxToRem({ px: 40 })};

    @media (max-width: ${breakpoints.beforeDesktop.rem}) {
        margin-bottom: ${convertPxToRem({ px: 36 })};
    }

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        margin-bottom: ${convertPxToRem({ px: 32 })};
    }

    &:hover {
        ${SHARED_FORM_STYLES.HOVER}
    }

    &:focus {
        ${SHARED_FORM_STYLES.FOCUS}
    }

    &::placeholder {
        ${SHARED_FORM_STYLES.PLACEHOLDER}
    }
`;
